import React from "react";
import ChrDateRangePicker from "../../../Form/Compound/ChrDateRangePicker";
import useFilterWrapper from "../../../../../hooks/generic/FilterUI/useFilterWrapper";
import { getValueToDisplay, isValidData } from "./utils";
import { filterWrapperDropdownAlignment } from "../../../FilterUI/constants";
import { actionAlignment } from "../../constants";
import ChrTooltip from "../../../Form/Basic/ChrTooltip";
import { actionStatus } from "../../../FilterUI/constants";

/*
props = {
  uId: <uniqueIdentifier>,
  alignment: <'left' | 'right'>
  data: <Hash for ChrDateRangePicker>,
  dispatcher: <handler>,
  onSubmit: <handler>,
  onCancel: <handler>
}
*/

const DateFilter = (props) => {
  const {
    uId, data, alignment,
    lastSubmittedData, tooltip,
    wrapperClass, newUx = false
  } = props;
  const dropdownAlignment = (alignment === actionAlignment.RIGHT) && filterWrapperDropdownAlignment.RIGHT;
  const [FilterWrapper, filterWrapperOptions, filterWrapperActions] = useFilterWrapper({ alignment: dropdownAlignment });
  const calendarIcon = <i className="fa-regular fa-calendar-days" />;

  const onChangeHandler = (_event, _childUId, childData) => {
    props.dispatcher({ uId: uId, data: childData })
  }

  const onSubmitHandler = (event) => {
    filterWrapperActions.filterBodyVisibilitySetter(false);
    props.onSubmit(event);
  }
  const onCancelHandler = (event) => {
    filterWrapperActions.filterBodyVisibilitySetter(false);
    props.onCancel(event);
  }

  const lastSubmittedValue = getValueToDisplay(lastSubmittedData);
  const notSameAsLastSubmittedValue = lastSubmittedValue !== getValueToDisplay(data);
  const getSubmitActionState = () => notSameAsLastSubmittedValue && isValidData(data);

  filterWrapperOptions.actionState = {
    submit: getSubmitActionState() ? actionStatus.ENABLED : actionStatus.DISABLED
  }

  const getDescriptionComponent = () => {
    return (
      tooltip && <ChrTooltip
        content={ tooltip }
        iconClass={ 'fa-solid fa-circle-info align-self-center text-info font-14 pl-2' }
      />
    );
  }

  return (
    <FilterWrapper
      showFilter
      showActions
      title={ calendarIcon }
      currentValue={ lastSubmittedValue }
      onSubmitHandler={ onSubmitHandler }
      onCancelHandler={ onCancelHandler }
      headerSuffixConstructor={ getDescriptionComponent }
      { ...filterWrapperOptions }
      additionalWrapperClass={ `${wrapperClass} ${filterWrapperOptions.additionalWrapperClass} no-margins` }
      buttonSize='sm'
      rounded
      headerWidthClass='custom-max-width-22'
      newUx={ newUx }
    >
      <ChrDateRangePicker uId={ uId } data={ data } onChange={ onChangeHandler } />
    </FilterWrapper>
  )
}

export default DateFilter;
